<template>
  <Modal
    size="bigLarge"
    title="自定义列"
    @on-ok="onOk"
    ref="Modal">
    <ModalLayout>
      <DragInlineTable
        :autoHeight="true"
        ref="TableLeft"
        noSearch
        :showEdit="false"
        :showDelete="false"
        :staticData="true"
        :showSelect="false"
        :showPage="false"
        :disabledDrag="false"
        :showElevator="false"
        :columns="layoutConfig.leftColumns"
        :tableData="leftData"></DragInlineTable>
      <p class="iv-text-center iv-line-wrapper iv-symbol-mt16">
        <span class="iv-br"></span>
        <span class="iv-text">以上为锁定列头</span>
      </p>
      <div class="iv-p-r-4" style="text-align: right">
        <Button
          type="add"
          class="iv-pointer"
          @click="addUser">
          <span>添加</span>
        </Button>
      </div>
      <DragInlineTable
        :autoHeight="true"
        :show-header="false"
        :showSelect="false"
        ref="TableMiddle"
        class="iv-symbol-mb16 iv-symbol-mt16"
        noSearch
        @on-list="onList"
        :showEdit="false"
        :showDelete="false"
        :staticData="true"
        :showPage="false"
        :disabledDrag="false"
        :columns="layoutConfig.localColData"
        :tableData="data"></DragInlineTable>
      <p class="iv-text-center iv-line-wrapper iv-symbol-mt16 iv-symbol-mb16">
        <span class="iv-br"></span>
        <span class="iv-text">以下为锁定列头</span>
      </p>
      <DragInlineTable
        :autoHeight="true"
        :showSelect="false"
        :showEdit="false"
        :showDelete="false"
        :show-header="false"
        ref="TableRight"
        noSearch
        :staticData="true"
        :showPage="false"
        :disabledDrag="false"
        :columns="layoutConfig.rightColData"
        :tableData="rightData"></DragInlineTable>
    </ModalLayout>
    <div slot="footer">
      <Button
        type="submit"
        noIcon
        class="uit-ok"
        @click="onOk(true)">
        <span>应用</span>
      </Button>
      <Button
        type="waive"
        noIcon
        class="iv-m-l-8 uit-cancel"
        @click="onCancel">
        <span>取消</span>
        <!-- 放弃 -->
      </Button>
      <Button
        type="waive"
        noIcon
        class="iv-m-l-8 uit-cancel"
        @click="onDefault">
        <span>恢复默认设置</span>
        <!-- 放弃 -->
      </Button>
    </div>
  </Modal>
</template>
<script>
import { getSettingList, getSystemDefault, savePageItem } from './interface'
import vuedraggable from 'vuedraggable'
import ModalLayout from '@/components/modal/layout'
import Modal from '@/components/modal'
import Layout from '@/components/modal/layout'
import layoutConfig from './columns'
export default {
  props: {
    leftLocalColData: {
      type: Array,
      default () {
        return []
      }
    },
    localColData: {
      type: Array,
      default () {
        return []
      }
    },
    rightLocalColData: {
      type: Array,
      default () {
        return []
      }
    },
    menuCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      menuCodeString: '',
      dataTable: [],
      dataList: {},
      groupPatchList: [],
      move: false,
      currentDrag: '',
      rightData: [],
      leftData: [],
      data: [],
      viewLock: false
    }
  },
  watch: {
    leftLocalColData (val) {
      this.leftData = val
    },
    localColData (val) {
      this.data = val
    },
    rightLocalColData (val) {
      this.rightData = val
    }
  },
  components: {
    vuedraggable,
    Modal,
    Layout,
    ModalLayout
  },
  provide () {
    return {
      handlerOperateEvent: this.handlerOperateEvent,
      setSortIndex: this.setSortIndex,
      interceptor: {
        response: {
          resolve: (data) => {
            return data
          }
        }
      }
    }
  },
  created () {
    this.pageList = JSON.parse(sessionStorage.getItem('crumbsList'))
    this.savePageItem = savePageItem
    this.getSystemDefault = getSystemDefault
    this.layoutConfig = layoutConfig.call(this)
  },
  methods: {
    onList (list) {
      this.dataTable = list
    },
    handlerOperateEvent (item, list) {
      this.$refs.TableLeft.$refs.Table.rebuildData.forEach((item, index) => {
        if (item.itemPropertie == list.itemPropertie) {
          this.$refs.TableLeft.$refs.Table.rebuildData.splice(index, 1)
        }
      })
      this.$refs.TableMiddle.$refs.Table.rebuildData.forEach((item, index) => {
        if (item.itemPropertie == list.itemPropertie) {
          this.$refs.TableMiddle.$refs.Table.rebuildData.splice(index, 1)
        }
      })
      this.$refs.TableRight.$refs.Table.rebuildData.forEach((item, index) => {
        if (item.itemPropertie == list.itemPropertie) {
          this.$refs.TableRight.$refs.Table.rebuildData.splice(index, 1)
        }
      })
    },
    addUser () {
      if (this.data.length == 0) {
        this.data.unshift({
          'activeState': 1,
          'itemPropertie': '',
          'itemTitle': '',
          'itemWidth': null,
          'itemMinWidth': null
        })
      } else {
        this.$refs.TableMiddle.$refs.Table.rebuildData.unshift({
          'activeState': 1,
          'itemPropertie': '',
          'itemTitle': '',
          'itemWidth': null,
          'itemMinWidth': null
        })
      }
    },
    onDefault () {
      getSystemDefault({
        groupCode: this.menuCode
      }).then((res) => {
        this.dataList = res.data
        this.groupPatchList = res.data.groupPatchList
        res.data.groupPatchList.forEach(item => {
          if (item.patchCode == 'left') {
            this.leftData = item.listItemList
          } else if (item.patchCode == 'center') {
            this.data = []
            this.data = item.listItemList
          } else if (item.patchCode == 'right') {
            this.rightData = []
            this.rightData = item.listItemList
          }
        })
        setTimeout(() => {
          this.$methods('TableLeft', 'forceRender')
          this.$methods('TableMiddle', 'forceRender')
          this.$methods('TableRight', 'forceRender')
        }, 1000)
      })
    },
    setSortIndex (oldIndex, newIndex, z) {
    },
    changeData (table, to, data) {
      if (table == 'TableMiddle') {
        for (var y = this.$refs.TableMiddle.$refs.Table.rebuildData.length - 1; y >= 0; y--) {
          if (this.$refs.TableMiddle.$refs.Table.rebuildData[y].itemId === data.itemId) {
            this.$refs.TableMiddle.$refs.Table.rebuildData.splice(y, 1)
          }
        }
        if (to == 'down') {
          this.$refs.TableRight.$refs.Table.rebuildData.unshift(data)
          this.rightData.unshift(data)
        }
        if (to == 'up') {
          this.$refs.TableLeft.$refs.Table.rebuildData.unshift(data)
          this.leftData.unshift(data)
        }
      } else if (table == 'TableRight') {
        for (var z = this.$refs.TableRight.$refs.Table.rebuildData.length - 1; z >= 0; z--) {
          if (this.$refs.TableRight.$refs.Table.rebuildData[z].itemId === data.itemId) {
            this.$refs.TableRight.$refs.Table.rebuildData.splice(z, 1)
          }
        }
        this.$refs.TableMiddle.$refs.Table.rebuildData.unshift(data)
        this.data.unshift(data)
      } else if (table == 'TableLeft') {
        for (var i = this.$refs.TableLeft.$refs.Table.rebuildData.length - 1; i >= 0; i--) {
          if (this.$refs.TableLeft.$refs.Table.rebuildData[i].itemId === data.itemId) {
            this.$refs.TableLeft.$refs.Table.rebuildData.splice(i, 1)
          }
        }
        this.data.unshift(data)
        this.$refs.TableMiddle.$refs.Table.rebuildData.unshift(data)
      }
    },
    onCancel () {
      this.$methods('Modal', 'close')
    },
    open (menuCode) {
      this.$methods('Modal', 'open')
      getSettingList({
        groupCode: menuCode
      }).then((res) => {
        this.dataList = res.data
        this.groupPatchList = res.data.groupPatchList
        res.data.groupPatchList && res.data.groupPatchList.forEach(item => {
          if (item.patchCode == 'left') {
            this.leftData = item.listItemList
          } else if (item.patchCode == 'center') {
            this.data = item.listItemList
          } else if (item.patchCode == 'right') {
            this.rightData = item.listItemList
          }
        })
        this.$nextTick(() => {
          this.$methods('TableLeft', 'forceRender')
          this.$methods('TableMiddle', 'forceRender')
          this.$methods('TableRight', 'forceRender')
        }, 100)
      })
    },
    onOk () {
      let that = this
      !this.groupPatchList && (this.groupPatchList = [{
        formItemList: [],
        listItemList: [],
        groupPatchId: '',
        patchCode: 'right',
        patchName: '固定表头右'
      }, {
        formItemList: [],
        listItemList: [],
        groupPatchId: '',
        patchCode: 'center',
        patchName: '中间表头'
      }, {
        formItemList: [],
        listItemList: [],
        groupPatchId: '',
        patchCode: 'left',
        patchName: '固定表头左'
      }])
      let i = 0
      if (this.groupPatchList.length == 2) {
        this.groupPatchList.push({
          formItemList: [],
          listItemList: [],
          groupPatchId: '',
          patchCode: 'left',
          patchName: '固定表头左'
        })
      }
      this.groupPatchList.forEach(item => {
        if (item.patchCode == 'left') {
          item.listItemList = this.$refs.TableLeft.$refs.Table.rebuildData
        } else if (item.patchCode == 'center') {
          item.listItemList = this.$refs.TableMiddle.$refs.Table.rebuildData
        } else if (item.patchCode == 'right') {
          item.listItemList = this.$refs.TableRight.$refs.Table.rebuildData
        }
      })
      this.$refs.TableLeft.$refs.Table.rebuildData.forEach(item => {
        if (item.itemPropertie == '' || item.itemTitle == '') {
          i += 1
        }
      })
      this.$refs.TableMiddle.$refs.Table.rebuildData.forEach(item => {
        if (item.itemPropertie == '' || item.itemTitle == '') {
          i += 1
        }
      })
      this.$refs.TableRight.$refs.Table.rebuildData.forEach(item => {
        if (item.itemPropertie == '' || item.itemTitle == '') {
          i += 1
        }
      })
      if (i == 0) {
        savePageItem({
          moduleName: that.dataList.moduleName || this.pageList[0].title,
          moduleCode: that.dataList.moduleCode || this.pageList[0].id,
          pageName: that.dataList.pageName || this.pageList[this.pageList.length - 1].title || this.pageList[this.pageList.length - 1].id,
          pageCode: that.dataList.pageCode || this.pageList[this.pageList.length - 1].id,
          groupName: that.dataList.groupName || this.menuCode,
          groupCode: that.dataList.groupCode || this.menuCode,
          groupType: 'LIST',
          groupPatchList: this.groupPatchList
        }).then(res => {
          this.$methods('Modal', 'close')
          this.$emit('on-custom-table')
          this.$Message.success('保存成功')
        })
      } else {
        this.$Message.error('字段名称，显示名称不能为空')
      }      
    },
    getColumns (key) {
      return [{
        title: '启用',
        width: 100,
        [$field]: 'isEnabled',
        isEdit: true,
        render: (h, params) => {
          return h('Checkbox', {
            props: {
              value: params.row.isEnabled
            },
            on: {
              'on-change': (e) => {
                params.row.isEnabled = e
              }
            }
          })
        }
      }, {
        title: '字段名称',
        [$field]: 'key'
      }, {
        title: '显示名称',
        [$field]: 'title',
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row.title
            },
            on: {
              'input': v => {
                this[key][index].title = ~~(v)
              }
            }
          })
        }
      }, {
        title: '显示宽度',
        [$field]: 'width',
        width: 150,
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row._width || row.width
            },
            on: {
              'input': v => {
                this[key][index]._width = ~~(v)
              }
            }
          })
        }
      }, {
        title: '最小显示宽度',
        [$field]: 'minwidth',
        width: 150,
        render: (c, {row, index}) => {
          return c('Input', {
            props: {
              value: row._width || row.width
            },
            on: {
              'input': v => {
                this[key][index]._width = ~~(v)
              }
            }
          })
        }
      }]
    },
    resetChoose (data, targetData) {
      targetData.forEach(col => !(col.required && col._disabled) && delete col._checked)
      data.forEach(c => {
        let col = targetData.find(col => col.key === c.key)
        if (!col) return
        Object.assign(col, c, {
          _checked: true
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.iv-line-wrapper {
  position: relative;
  .iv-br {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background: #ccc;
    top: 50%;
  }
  .iv-text {
    position: relative;
    background: #fff;
    padding: 0 8px;
  }
}
</style>
